import _toConsumableArray from "/Users/harsha919/Desktop/ONESAZ/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/Users/harsha919/Desktop/ONESAZ/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toArray from "/Users/harsha919/Desktop/ONESAZ/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toArray";
import { unpack } from '../../utils/index.js';
import lch2lab from '../lch/lch2lab.js';
import oklab2rgb from '../oklab/oklab2rgb.js';
var oklch2rgb = function oklch2rgb() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  args = unpack(args, 'lch');
  var _args = args,
    _args2 = _toArray(_args),
    l = _args2[0],
    c = _args2[1],
    h = _args2[2],
    rest = _args2.slice(3);
  var _lch2lab = lch2lab(l, c, h),
    _lch2lab2 = _slicedToArray(_lch2lab, 3),
    L = _lch2lab2[0],
    a = _lch2lab2[1],
    b_ = _lch2lab2[2];
  var _oklab2rgb = oklab2rgb(L, a, b_),
    _oklab2rgb2 = _slicedToArray(_oklab2rgb, 3),
    r = _oklab2rgb2[0],
    g = _oklab2rgb2[1],
    b = _oklab2rgb2[2];
  return [r, g, b].concat(_toConsumableArray(rest.length > 0 && rest[0] < 1 ? [rest[0]] : []));
};
export default oklch2rgb;